// ---------------------------------------------------------------------------
// F3e C6 — MENSAGENS de histórico (só diagnóstico, só com "?dbg=1"): quando cada uma apareceu, por quê, por quanto
// tempo e o código de resposta da fonte que a causou. Só nas mudanças de mensagem (nada por quadro).
// ---------------------------------------------------------------------------

import { DBG_ENABLED } from './dbgFlag';
import type { Msg } from './historyMessage';

const CAP = 40;
export interface MsgReg { t0: number; t1: number; tipo: string; texto: string; motivo: string; status: string }

class MsgProbe {
  list: MsgReg[] = [];
  private cur: MsgReg | null = null;
  /** chamada quando a mensagem na tela muda (null = nenhuma); `status` = código da fonte (falha) */
  mudou(now: number, msg: Msg | null, status: number | null): void {
    if (this.cur) { this.cur.t1 = now; this.cur = null; }
    if (!msg) return;
    const r: MsgReg = { t0: now, t1: NaN, tipo: msg.tipo, texto: msg.texto, motivo: msg.motivo, status: status === null ? '—' : String(status) };
    this.cur = r; this.list.push(r); if (this.list.length > CAP) this.list.shift();
  }
  report(t0Abs: number, max: number, now: number): string[] {
    const by = (k: string) => this.list.filter(r => r.tipo === k).length;
    const L = [`=== MENSAGENS: ${this.list.length} | erro ${by('erro')} | início ${by('inicio')} | carregando ${by('carregando')} ===`];
    for (const r of this.list.slice(-max)) {
      const dur = (Number.isFinite(r.t1) ? r.t1 : now) - r.t0;
      L.push(`t=${((r.t0 - t0Abs) / 1000).toFixed(1)}s ${r.tipo} ${(dur / 1000).toFixed(1)}s${Number.isFinite(r.t1) ? '' : ' (na tela)'} | "${r.texto}" | por quê: ${r.motivo} | fonte: ${r.status}`);
    }
    return L;
  }
}

export const msgProbe = DBG_ENABLED ? new MsgProbe() : null;
// replay (tests/replay): a seção sai no relatório do harness
if (msgProbe && typeof window !== 'undefined') (window as any).__msgProbe = msgProbe;
